import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Button } from 'grommet'

export const ExperienceLaunchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
`

export const LinkExpiryCaption = styled.span`
  font-family: ${themeGet('font.molde.medium')};
  font-size: 0.75rem;
  color: ${themeGet('colors.darkGray', '#6b6b6b')};
  white-space: nowrap;
`

export const ExperienceLaunchButton = styled(Button)`
  background: ${themeGet('colors.buttons.primary.bgActive')};
  color: ${themeGet('colors.buttons.primary.titleActive')};
  border-radius: 0.5rem;
  padding: 1.3125rem;
  padding-top: 0.688rem;
  padding-bottom: 0.563rem;
  font-family: ${themeGet('font.molde.medium')};
  font-size: 1rem;
  text-align: center;
  width: ${props =>
    props.$isHighSchoolButton || props.$forceFixedWidth ? '9.375rem' : 'auto'};
  height: ${props => (props.$isHighSchoolButton ? '2.6875rem' : 'auto')};
  min-width: ${props =>
    props.$isHighSchoolButton || props.$forceFixedWidth ? '9.375rem' : 'auto'};
  min-height: ${props => (props.$isHighSchoolButton ? '2.6875rem' : 'auto')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  ${props =>
      props.$isHighSchoolButton
        ? `
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    line-height: 1;
  `
        : ''}
    :hover {
    background: ${themeGet('colors.buttons.primary.bgHover')};
    color: ${themeGet('colors.buttons.primary.titleHover')};
  }

  :disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
